define.alias("shared/components/shared/ui/switcher/action", "calendar/components/shared/ui/switcher/action");